import { createSafeVideoElement } from "./safeBlobUtils";

/**
 * Utility functions for detecting keyframe offsets in trimmed videos
 */

/**
 * Gets the keyframe offset (actual start time) of a video file
 * This is particularly useful for trimmed videos that don't start at 0
 */
export async function getVideoKeyframeOffset(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
        const videoManager = createSafeVideoElement(file, { preload: "metadata" });
        const video = videoManager.element;

        video.onloadedmetadata = () => {
            try {
                // Use seek-to-0 method as primary detection (most reliable for trimmed videos)
                // The browser will automatically seek to the first available keyframe
                video.currentTime = 0;

                // Wait for the seek to complete
                const handleSeeked = () => {
                    video.removeEventListener("seeked", handleSeeked);
                    const actualStartTime = video.currentTime;
                    // console.log(
                    //     "🎬 [KEYFRAME OFFSET] Actual start after seek to 0:",
                    //     actualStartTime
                    // );
                    videoManager.cleanup();
                    resolve(actualStartTime);
                };

                video.addEventListener("seeked", handleSeeked);

                // Fallback timeout in case seeked event doesn't fire
                setTimeout(() => {
                    video.removeEventListener("seeked", handleSeeked);
                    const actualStartTime = video.currentTime;
                    // console.log("🎬 [KEYFRAME OFFSET] Fallback actual start:", actualStartTime);
                    videoManager.cleanup();
                    resolve(actualStartTime);
                }, 1000);
            } catch (error) {
                videoManager.cleanup();
                reject(error);
            }
        };

        video.onerror = (error) => {
            videoManager.cleanup();
            reject(error);
        };

        video.load();
    });
}
